import request from "~/utils/http";

const shippingPriceApi = {
	gets : async (params) => {
		const url = 'v1/shipping-price';
		return await request.get(url, {params});
	},
	getById : async (id) => {
		const url = `v1/shipping-price/${id}`;
		return await request.get(url);
	},
	add : async (params) => {
		const url = 'v1/shipping-price';
		return await request.post(url, params);
	},
	duplicate : async (params) => {
		const url = `v1/shipping-price/duplicate/${params.id}`;
		return await request.post(url, params);
	},
	update : async (params) => {
		const url = `v1/shipping-price/${params.id}`;
		return await request.post(url, params);
	},
	delete : async (id) => {
		const url = `v1/shipping-price/${id}`;
		return await request.delete(url);
	},
	default : async (id) => {
		const url = `v1/shipping-price/default/${id}`;
		return await request.post(url);
	},
	updateUsers : async (params) => {
		const url = `v1/shipping-price/multiple-user/${params.id}`;
		return await request.post(url, params);
	},
	addAff : async (params) => {
		const url = 'v1/shipping-price/aff';
		return await request.post(url, params);
	},
	status : async (params) => {
		const url = `v1/shipping-price/status/${params.id}`;
		return await request.post(url, params);
	},
};

export default shippingPriceApi;